module.exports = __webpack_public_path__ + "78656a726573882407a3132da073900d.svg";